var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 69,
    rx: 34.5,
    stroke: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0618 21.3951C38.672 20.785 39.6613 20.785 40.2715 21.3951L52.7715 33.8951C53.3817 34.5053 53.3817 35.4947 52.7715 36.1049L40.2715 48.6049C39.6613 49.215 38.672 49.215 38.0618 48.6049C37.4516 47.9947 37.4516 47.0053 38.0618 46.3951L47.8945 36.5625H18.3333C17.4704 36.5625 16.7708 35.8629 16.7708 35C16.7708 34.1371 17.4704 33.4375 18.3333 33.4375H47.8945L38.0618 23.6049C37.4516 22.9947 37.4516 22.0053 38.0618 21.3951Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledArrowBlack);
export default __webpack_public_path__ + "static/media/circled-arrow-black.47a0af1bba6aac719574a1ece32eb8c1.svg";
export { ForwardRef as ReactComponent };